module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-left-white-no-fill-1d639d155c05b68832e5bea5ffdcb9d5.svg";